import React from 'react';
import clsx from 'clsx';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import Styles from './ChatPagesContainer.module.scss';
import { ChatDealListPane } from '~/components/common/chat/deal_list/ChatDealListPane';
import { ChatMessagePane } from '~/components/common/chat/messages/ChatMessagePane';
import type { MessageSummary } from '~/models/MessageSummary';
import type { ItandiAccount } from '~/models/ItandiAccount';

type Props = DeepReadonly<{
  isVendor?: boolean;
  isAdmin?: boolean;
  store?: ItandiAccount['store'] | null;
  handleTemporaryUnread: (dealId: number) => Promise<void>;
}>;

type SelectedState = {
  selectedSummary: MessageSummary | null;
  setSelectedSummary?: (summary: MessageSummary | null) => void;
};
const SelectedContext = React.createContext<SelectedState>({
  selectedSummary: null,
  setSelectedSummary: undefined
});
export const useMessageSelectedContext = (): SelectedState =>
  React.useContext<SelectedState>(SelectedContext);

/**
 * 案件を横断してやり取りを管理できるチャット画面
 *
 * @param isVendor
 * @param isAdmin
 * @param store
 * @param handleTemporaryUnread
 * @constructor
 */
export const ChatPagesContainer: React.FC<Props> = ({
  isVendor = false,
  isAdmin = false,
  store = null,
  handleTemporaryUnread
}: Props) => {
  const [selectedSummary, setSelectedSummary] =
    React.useState<MessageSummary | null>(null);
  const providerValue = React.useMemo(
    () => ({ selectedSummary, setSelectedSummary }),
    [selectedSummary]
  );
  return (
    <div className={clsx(Styles.Container, !isVendor && Styles.Client)}>
      <SelectedContext.Provider value={providerValue}>
        <div className={Styles.MainArea}>
          <ChatDealListPane isVendor={isVendor} store={store} />
          {selectedSummary !== null && (
            <ChatMessagePane
              handleTemporaryUnread={handleTemporaryUnread}
              isAdmin={isAdmin}
              isVendor={isVendor}
            />
          )}
        </div>
      </SelectedContext.Provider>
    </div>
  );
};
